<template>
    <div>
        <div class="d-flex justify-content-between mb-5">
            <div>
                <h1 class="font-weight-bold mb-0" v-text="course.title"></h1>
                <div v-text="user.full_name"></div>
                <div>
                    <span class="font-weight-bold" style="color: rgba(0, 0, 0, 0.7);">Class Date:</span> <span v-text="shortDateTime(schedule.date)"></span>
                </div>
                <div>
                    <span class="font-weight-bold" style="color: rgba(0, 0, 0, 0.7);">Current Playing:</span> <span v-text="currentSegment.model.title"></span>
                </div>
                <div>
                    <span class="font-weight-bold" style="color: rgba(0, 0, 0, 0.7);">Total Progress:</span> <span v-text="toFixed(videos.total_progress)"></span>%
                </div>
            </div>
            <div>
                <a class="logo" href="/">
                    <img class="logo" src="/images/logo.svg" alt="California Electrical Training">
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['course', 'schedule', 'currentSegment', 'videos', 'user'],

    methods: {
        toFixed(value) {
            return value.toFixed(0)
        }
    }
}
</script>
